import { render } from "./NavigateNext.vue?vue&type=template&id=a1647960"
import script from "./NavigateNext.vue?vue&type=script&lang=js"
export * from "./NavigateNext.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__